import React, { useEffect, useState } from 'react';
import CustomWarranteeToolbar from './CustomWarranteeToolbar';
import { getCabinetType } from '../../Helpers/requests';
import WarranteeNotes from './WarranteeNotes';
import { filterMethod } from '../../Helpers/helpers';
import {
  gridStyle,
  modalStyle600,
  modalStyle900,
  modalStyle1024,
} from '../shared/commonStyle';
import { APIROOT } from '../../Helpers/configs';
import { DataGrid } from '@mui/x-data-grid';
import {
  Button,
  Modal,
  Box,
  Grid,
  Stack,
  Typography,
  Card,
  Divider,
  TextField,
  Autocomplete,
} from '@mui/material/';
import { TableUpdate } from '../../Helpers/requests';
import { GetAuth } from '../../Auth/AuthProvider';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function WarranteeMainCard(props) {
  const [filterModalEventFields, setFilterModalEventFields] = useState({
    storeCabinet: '',
  });

  const [filterOpen, setFilterOpen] = useState(false);
  const handleFilterOpen = () => setFilterOpen(true);
  const handleFilterClose = () => setFilterOpen(false);
  const filterCabinetOptions = filterMethod;

  const [cabinetTypeList, setCabinetTypeList] = useState([]);

  const [fullFilterCabinetType, setFullFilterCabinetType] = useState('');

  const [modalState, setModalState] = useState('notSet');

  const [forceUpdate, setForceUpdate] = useState(1);
  const [data, setData] = useState([]); //data displayed in datagrid
  const [page, setPage] = useState(0); //Active page of table - starts at 0!
  const [filter, setFilter] = useState([]); //Current applied filter modal
  const [sort, setSort] = useState([]); //Current applied sorting modal
  const [loading, setLoading] = useState(false); //Loading indicator - used by datagrid
  // const [activeRow, setActiveRow] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize, setPageSize] = useState(20); //Number of rows to display
  const [totalRows, setTotalRows] = useState(0); //Total Number of rows in set
  const [updateData, setUpdateData] = useState(0); //Increment to force update dataset
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [uriPath, seturiPath] = useState('warnties');
  const [columns, setColumns] = useState([
    {
      field: 'serial_number',
      headerName: 'Cabinet Type',
      minWidth: 220,
      flex: 1,
      editable: true,
    },
  ]);

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setFullFilterCabinetType(filterModalEventFields.storeCabinet);

    setModalState('isSet');
    handleFilterClose();
  };

  const clearFilterEntries = (e) => {
    e.preventDefault();
    setModalState('notSet');
    setFilterModalEventFields({
      ...filterModalEventFields,
      storeCabinet: '',
    });
    setFullFilterCabinetType('');

    // handleFilterClose();
  };
  const handleAutoComplete = (event) => {
    setFilterModalEventFields({
      ...filterModalEventFields,
      storeCabinet: event.target.value,
    });
  };

  useEffect(() => {
    getCabinetType({
      resource: `/api/warranties`,
      setCabinetTypesFunc: setCabinetTypeList,
      logout,
    });
  }, [logout]);

  // const filterCabinetOptions = filterMethod;

  const warranteeEndpoint = (uri) => {
    deleteUnused(formFields);
    const DataBlob = {
      warranty: formFields,
    };
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');

    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = {};
    body = DataBlob;
    const request = new Request(`${APIROOT}/api/warranties${uri}`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });

    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save serial`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          setForceUpdate((val) => val + 1);

          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
          handleClose();
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : 'Connection Error',
          'error'
        );
      });
  };

  const [formFields, setFormFields] = useState({});
  // const [, setModalData] = useState([]);
  const [, setEditOrSave] = useState('saveMode');
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [warranteeEditTitle, setWarranteeEditTitle] =
    useState('Add Warrantee Info');

  // const warranteesData = [...fakeWarranteeData];
  //Update Table when page,number of rows (pageSize), sort & filter models or force update (updateData) changes
  useEffect(() => {
    TableUpdate({
      resource: `/api/warranties`,
      setColumnFunc: setColumns,
      setDataFunc: setData,
      pageNum: page,
      setLoadingFunc: setLoading,
      pagesize: pageSize,
      sorting: sort,
      filtering: filter,
      showNotification: enqNotification,
      setRows: setTotalRows,
      logout,
      fullFilterCabinetType: fullFilterCabinetType,
    });
  }, [
    page,
    pageSize,
    sort,
    filter,
    updateData,
    enqNotification,
    logout,
    forceUpdate,
    fullFilterCabinetType,
  ]);

  // const getMyRowData = (modalRowData) => {
  //   let settingData = modalRowData;

  //   setModalData(settingData);
  // };

  const deleteUnused = (obj) => {
    delete obj.id;
  };

  //SPREAD COLUMNS AND ADD ACTION COLUMNS
  const actionsColumn = [
    ...columns,
    {
      field: 'actionsColumn',
      headerName: 'Actions',
      width: 150,
      sortable: false,
      flex: 1,
      renderCell: (props) => (
        <>
          <Button
            xs={{ float: 'right' }}
            variant='contained'
            size='small'
            onClick={() => {
              seturiPath(`/${props.row['id']}`);
              setFormFields(props.row);
              setWarranteeEditTitle('Edit Warrantee Info');
              handleOpen();
              setEditOrSave('editMode');
            }}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];
  // console.log(`${JSON.stringify(actionsColumn, null, '\t')}`);

  useEffect(() => {
    columns.map((resp) =>
      setFormFields((formField) => ({ ...formField, [resp.field]: resp.value }))
    );
    if (formFields['serial_number']) {
      delete formFields['serial_number'];
    }
    return () => {};
  }, []);

  const handleChange = (e, field) => {
    setFormFields({
      ...formFields,
      [field]: e.target.value, //edit
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    warranteeEndpoint(uriPath);
  };

  // const removeUnusedKeyPair = () => {
  //   if ('serial_number' in formFields) {
  //     delete formFields['serial_number'];
  //   }
  // };

  // const getEditData = (rowObj, fieldObj) => {
  //   let spreadData = { ...formFields };
  //   Object.keys(rowObj).forEach((key) => {
  //     console.log(key, rowObj[key], typeof rowObj[key].toString());

  //     if (key !== 'id') {
  //       spreadData = { ...spreadData, [key]: rowObj[key] };
  //     }
  //   });

  //   setFormFields({
  //     ...spreadData,
  //   });
  // };

  return (
    <Card
      sx={{
        '.css-bhp9pd-MuiPaper-root-MuiCard-root': { boxShadow: 'none' },
        // maxHeight: '100%',
        minHeight: '100%',
        width: '100%',
        background: 'none',
        boxShadow: 'none',
        border: 'none',
      }}
    >
      <center>
        <div
          style={{
            height: '79vh',
            maxWidth: '100%',
            border: 'none',
            boxShadow: 'none',
            background: 'none',
          }}
        >
          <DataGrid
            sx={gridStyle}
            rows={data}
            rowCount={totalRows}
            loading={loading}
            pagination
            sortingMode='server'
            filterMode='server'
            onSortModelChange={(model) => {
              setPage(0);
              setSort(model);
            }}
            onFilterModelChange={(model) => {
              setPage(0);
              setFilter(model.quickFilterValues);
            }}
            page={page}
            pageSize={pageSize}
            paginationMode='server'
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPageSizeChange={(newPageSize) => {
              setPage(0);
              setPageSize(newPageSize);
            }}
            columns={actionsColumn}
            onRowDoubleClick={(params) => {
              seturiPath(`/${params.row['id']}`);
              setFormFields(params.row);
              setWarranteeEditTitle('Edit Warrantee Info');
              handleOpen();
              setEditOrSave('editMode');
            }}
            rowsPerPageOptions={[10, 20, 50, 100]}
            components={{ Toolbar: CustomWarranteeToolbar }}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            componentsProps={{
              toolbar: {
                updateOnclick: () => {
                  setUpdateData((i) => i + 1);
                },
                filterOnClick: () => {
                  handleFilterOpen();
                },
                modalState: modalState,
              },
            }}
          />
        </div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby='modal-warrantee'
          aria-describedby='modal-warrantee-description'
        >
          <Box md={modalStyle900} sx={modalStyle600} lg={modalStyle1024}>
            <form onSubmit={handleSubmit}>
              {' '}
              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 1, sm: 1, md: 1 }}
                rowGap={{ xs: 1, sm: 1, md: 1 }}
                style={{
                  background: '#84a1bc91',
                  padding: '5px 10px 15px 5px',
                  borderRadius: '5px',
                }}
              >
                <Grid item xs={12} md={12}>
                  <Typography variant='h5' sx={{ height: 40 }}>
                    {warranteeEditTitle}
                  </Typography>
                </Grid>

                {columns.map((resp) => (
                  <Grid item xs={12} md={3}>
                    <div className='mb-3' key={resp.headerName}>
                      <Grid item xs={12} md={12}>
                        <label
                          className='form-label text-capitalize'
                          key={resp.headerName}
                        >
                          {resp.headerName}
                        </label>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <input
                          key={resp.field}
                          style={{
                            width: '100%',
                            margin: '0 auto',
                            minHeight: '40px',
                            borderRadius: '5px',
                          }}
                          type={resp.field === 'name' ? resp.type : 'number'}
                          step='.01'
                          min='0'
                          max='30'
                          className='form-control'
                          required={resp.field === 'name' ? true : false}
                          defaultValue={formFields[resp.field]}
                          onChange={(e) => {
                            handleChange(e, resp.field);
                          }}
                        />
                      </Grid>
                    </div>
                  </Grid>
                ))}
              </Grid>
              {warranteeEditTitle === 'Edit Warrantee Info' ? (
                <WarranteeNotes
                  warranteeId={formFields.id}
                  relationType='warranteeTable'
                />
              ) : (
                ''
              )}
              <Button
                sx={{ margin: '20px 0 0 20px', float: 'right' }}
                variant='outlined'
                onClick={() => {
                  handleClose();
                }}
              >
                Cancel
              </Button>
              <Button
                sx={{ margin: '20px 0 0 0', float: 'right' }}
                variant='contained'
                type='submit'
                className='btn btn-primary'
              >
                Submit
              </Button>
            </form>
          </Box>
        </Modal>
        <Modal
          open={filterOpen}
          onClose={handleFilterClose}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <Box sx={modalStyle}>
            <form>
              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 1, sm: 1, md: 1 }}
                rowGap={{ xs: 1, sm: 1, md: 1 }}
                style={{
                  background: '#84a1bc91',
                  padding: '5px 10px 5px 5px',
                  borderRadius: '5px',
                }}
              >
                <Grid item xs={12} md={12}>
                  <Typography variant='h5' sx={{ height: 40 }}>
                    Filter
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant='h6' sx={{ height: 40 }}>
                    Cabinet Type:
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name='cabinetType'
                    key='cabinetType'
                    id='cabinetType'
                    size='small'
                    sx={{
                      width: '100%',
                      background: '#fff',
                      borderRadius: '5px',
                    }}
                    onChange={handleAutoComplete}
                    // onChange={(event, newValue) =>
                    //   handleAutoComplete('cabinetType', event.target.value)
                    // }
                    value={filterModalEventFields.storeCabinet}
                  />
                  {/* <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      padding: 0,
                    }}
                    name='cabinetType'
                    key='cabinetType'
                    id='cabinetType'
                    variant='standard'
                    size='small'
                    value={filterModalEventFields.storeCabinet}
                    // onChange={setCabinet}
                    onChange={(event, newValue) =>
                      handleAutoComplete('fullCabinet', newValue)
                    }
                    disablePortal
                    options={cabinetTypeList}
                    filterOptions={filterCabinetOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  /> */}
                </Grid>
              </Grid>
              <Button
                sx={{ margin: '20px 0 0 20px', float: 'right' }}
                variant='outlined'
                onClick={handleFilterClose}
              >
                Close
              </Button>
              <Button
                sx={{ margin: '20px 0 0 20px', float: 'right' }}
                variant='contained'
                type='submit'
                color='success'
                className='btn btn-primary'
                onClick={clearFilterEntries}
              >
                Clear Filter
              </Button>
              <Button
                sx={{ margin: '20px 0 0 0', float: 'right' }}
                variant='contained'
                type='submit'
                className='btn btn-primary'
                onClick={handleFilterSubmit}
                disabled={modalState === 'isSet' ? true : false}
              >
                Set Filter
              </Button>
            </form>
          </Box>
        </Modal>
      </center>
      <Stack
        spacing={2}
        direction='row'
        sx={{ float: 'right', margin: '15px' }}
      >
        <Button
          variant='contained'
          onClick={() => {
            seturiPath(``);
            setWarranteeEditTitle('Add Warrantee Info');
            handleOpen();
            setEditOrSave('editMode');
            setFormFields({});
          }}
        >
          Add New
        </Button>
      </Stack>
    </Card>
  );
}

export default WarranteeMainCard;
